module.exports = __webpack_public_path__ + "img/home_img_part_self.877dc0ed.png";